const DEV_HOSTS = new Set(['localhost', '0.0.0.0', '127.0.0.1', '::1'])
const DEFAULT_DOMAIN = 'rizz888.com'
// second-level public suffixes where the registrable domain has 3 labels
const MULTI_PART_TLDS = new Set([
  'co.th',
  'in.th',
  'ac.th',
  'go.th',
  'or.th',
  'net.th'
])

// Collapse any hostname to its registrable root domain:
// m.kaiju168.com -> kaiju168.com, foo.co.th stays foo.co.th.
// IP literals are returned as-is (they can't be sliced into a root domain).
export function toRootDomain(hostname) {
  const raw = (hostname || '').toLowerCase()
  if (!raw) return ''
  if (raw.includes(':') || /^\d{1,3}(\.\d{1,3}){3}$/.test(raw)) return raw
  const parts = raw.split('.')
  if (parts.length <= 2) return raw
  const lastTwo = parts.slice(-2).join('.')
  return MULTI_PART_TLDS.has(lastTwo) ? parts.slice(-3).join('.') : lastTwo
}

export default function getCurrentDomain() {
  const root = toRootDomain(window.location.hostname)
  if (!root || DEV_HOSTS.has(root) || root.includes(':') || /^\d/.test(root)) {
    return DEFAULT_DOMAIN
  }
  return root
}
